import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { AddCustomer as AddEmbeddedCustomer } from 'pages/EmbeddedCustomers/AddCustomer/AddCustomer'
import { AddCustomer as AddNestedCustomer } from 'pages/NestedCustomers/components/AddCustomer/AddCustomer'
import { CustomerModel, CustomerModels } from '../helpers/types'

export interface AddCustomerCtaProps {
  customerModel: CustomerModel
  refetchCustomers: () => void
}

export const AddCustomerCta = ({ customerModel, refetchCustomers }: AddCustomerCtaProps) => {
  const { t } = useTranslation()
  const [isAddCustomerSheetOpen, setIsAddCustomerSheetOpen] = useState(false)

  const onOpenAddNewCustomer = () => {
    setIsAddCustomerSheetOpen(true)
  }

  const onCloseAddNewCustomer = () => {
    setIsAddCustomerSheetOpen(false)
  }

  const onNewCustomerAdded = () => {
    refetchCustomers()
    onCloseAddNewCustomer()
  }

  return (
    <>
      <Button
        onClick={onOpenAddNewCustomer}
        name={t('customers.addNewCustomer')}
        iconElement={<Icon name="Plus" />}
      >
        {t('customers.addNewCustomer')}
      </Button>
      {customerModel === CustomerModels.EMBEDDED ? (
        <AddEmbeddedCustomer
          isOpen={isAddCustomerSheetOpen}
          onClose={onCloseAddNewCustomer}
          onCustomerAdded={onNewCustomerAdded}
        />
      ) : (
        <AddNestedCustomer
          isSheetOpen={isAddCustomerSheetOpen}
          handleCloseSheet={onCloseAddNewCustomer}
          handleOnSuccessCloseSheet={onNewCustomerAdded}
        />
      )}
    </>
  )
}
